/* Pill-style primary tabs (yellow active) and underline secondary tabs */
export function PrimaryTabs({ tabs, value, onChange, testIdPrefix = "tab" }) {
  return (
    <div className="flex gap-1 p-1 bg-[#0F1626] border border-[#1E2845] rounded-[12px] overflow-x-auto">
      {tabs.map((t) => (
        <button
          key={t.id}
          onClick={() => onChange(t.id)}
          data-testid={`${testIdPrefix}-${t.id}`}
          className={`px-4 py-2.5 rounded-[10px] text-[13px] font-bold whitespace-nowrap transition flex items-center gap-2 ${
            value === t.id
              ? "bg-[#F0B83A] text-[#0A0F1F]"
              : "text-[#8892A8] hover:text-[#E5E9F2]"
          }`}
        >
          {t.icon && <t.icon size={13} />}
          {t.label}
        </button>
      ))}
    </div>
  );
}

export function SecondaryTabs({ tabs, value, onChange, testIdPrefix = "subtab" }) {
  return (
    <div className="flex gap-1 mt-4">
      {tabs.map((t) => (
        <button
          key={t.id}
          onClick={() => onChange(t.id)}
          data-testid={`${testIdPrefix}-${t.id}`}
          className={`px-4 py-2 rounded-[8px] text-[12px] font-semibold whitespace-nowrap transition ${
            value === t.id
              ? "bg-[#F0B83A] text-[#0A0F1F]"
              : "text-[#8892A8] hover:text-[#E5E9F2] bg-transparent"
          }`}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

export function FilterChips({ options, value, onChange, testIdPrefix = "filter" }) {
  return (
    <div className="flex flex-wrap gap-1">
      {options.map((o) => (
        <button
          key={o.id || o}
          onClick={() => onChange(o.id || o)}
          data-testid={`${testIdPrefix}-${o.id || o}`}
          className={`px-3 py-1.5 rounded-[8px] text-[12px] font-semibold transition ${
            value === (o.id || o)
              ? "bg-[#F0B83A] text-[#0A0F1F]"
              : "bg-[#0F1626] border border-[#1E2845] text-[#8892A8] hover:text-[#E5E9F2]"
          }`}
        >
          {o.label || o}
        </button>
      ))}
    </div>
  );
}
